var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageContainer',{attrs:{"isLoading":_vm.isLoading,"error":_vm.error}},[_c('KnownActionForm',{attrs:{"known_action_id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }